var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9627 9.87288C25.8731 9.58376 25.6348 9.37306 25.3479 9.32941L17.2877 8.10157L13.683 0.445089C13.5548 0.172531 13.2899 0 13 0C12.7101 0 12.4453 0.172531 12.317 0.445089L8.71214 8.10157L0.652174 9.32941C0.365312 9.37306 0.126895 9.58376 0.0373174 9.87282C-0.0523112 10.1619 0.0224385 10.4793 0.230082 10.6914L6.06218 16.6512L4.68561 25.0665C4.63656 25.3661 4.75406 25.6688 4.98862 25.8475C5.12131 25.9486 5.27848 26 5.43641 26C5.55767 26 5.67934 25.9697 5.79076 25.9083L13 21.935L20.2089 25.9082C20.4656 26.0497 20.7765 26.0261 21.0111 25.8475C21.2457 25.6688 21.3632 25.366 21.3142 25.0664L19.9372 16.6512L25.7699 10.6913C25.9775 10.4793 26.0523 10.1619 25.9627 9.87288Z",
    fill: "#0741AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIconFilled);
export default __webpack_public_path__ + "static/media/startIconFilled.7ba9c243.svg";
export { ForwardRef as ReactComponent };